import React, { Component } from 'react';
import { Form } from 'antd';
import './index.less';
class FormItem extends Component {
  constructor() {
    super();
  }
  render() {
    const { form, item } = this.props;
    const { getFieldDecorator } = form;
    const { name, label, options, component, children } = item;
    return (
      <div>
        {children ? (
          <Form.Item {...label}>
            {getFieldDecorator(name, { ...options })(component)}
            {children.map(item => {
              const { name, label, options, component, children } = item;
              return (
                <span className="mar-l-10" key={name}>
                  {getFieldDecorator(name, { ...options })(component)}
                </span>
              );
            })}
          </Form.Item>
        ) : (
          <Form.Item {...label}>
            {getFieldDecorator(name, { ...options })(component)}
          </Form.Item>
        )}
      </div>
    );
  }
}
export default FormItem;
